<div class="modal-container">
  <h3 mat-dialog-title>{{ data.message }}</h3>

  <div mat-dialog-content>
    <div class="quick-actions-container">
      <div class="form-check">
        <input class="efx-check" type="checkbox" [(ngModel)]="balancesCero" id="checkBalances">
        <label class="efx-label" for="checkBalances">Deja todos los Balances en Cero (0)</label>
      </div>
      <div class="form-check">
        <input class="efx-check" type="checkbox" [(ngModel)]="contadoresCero" id="checkContadores">
        <label class="efx-label" for="checkContadores">Deja todos los Contadores de Atraso en Cero (0)</label>
      </div>
    </div>

    <hr>

      <div class="detailed-edit-container">
        <h6 class="efx-title-6">Editar campos específicos:</h6>
        <form [formGroup]="form">
          <div class="rows-container" formArrayName="camposUpdate">

            @for (control of arrayUpdatesControl.controls; track control; let i = $index) {
              <div class="edit-row" [formGroupName]="i">
                <div class="form-field">
                  <label class="efx-label">Campo a modificar</label>
                  <select class="efx-select" formControlName="fieldToChange" (change)="control.patchValue({ newValue: null })" #selectField>
                    <option value="" disabled hidden>Seleccionar campo</option>
                    @for (field of getAvailableFields(i); track field) {
                      <option [value]="field.name">{{ field.label }}</option>
                    }
                  </select>
                </div>
                <div class="row-separator">
                  <p>=</p>
                </div>
                <div class="form-field">
                  <label class="efx-label">Nuevo Valor</label>
                  <div>
                    @switch (getInputType(i)) {
                      @case ('date') {
                        <input
                          class="efx-input"
                          type="date"
                          formControlName="newValue"
                          [disabled]="!selectField.value">
                      }
                      @case ('select') {
                        <select
                          class="efx-select"
                          formControlName="newValue"
                          [disabled]="!selectField.value">
                          <option [ngValue]="null" disabled hidden>Seleccionar</option>
                          @for (opt of getSelectOptions(i); track opt) {
                            <option [value]="opt.code">
                              {{ opt.description }}
                            </option>
                          }
                        </select>
                      }
                      @default {
                        <input
                          class="efx-input"
                          type="text"
                          formControlName="newValue"
                          [disabled]="!selectField.value">
                      }
                    }
                  </div>
                </div>
                <div class="row-actions">
                  @if (i === arrayUpdatesControl.length - 1) {
                    <button type="button" class="btn-icon btn-add" (click)="agregarCampoVacio()">
                      <span class="material-symbols-outlined">add</span>
                    </button>
                  }
                  @if (arrayUpdatesControl.length > 1) {
                    <button type="button" class="btn-icon btn-delete" (click)="eliminarCampo(i)">
                      <span class="material-symbols-outlined">delete</span>
                    </button>
                  }
                </div>
              </div>
            }
          </div>

          @if (arrayUpdatesControl.length === 0) {
            <button type="button" class="efx-button-tertiary mt-2" (click)="agregarCampoVacio()">
              <span class="material-symbols-outlined">add</span> Añadir campo
            </button>
          }

        </form>
      </div>
    </div>

    <div mat-dialog-actions class="form-footer">
      <button class="efx-button-secondary" (click)="onNoClick()">Cancelar</button>
      <button class="efx-button-primary" (click)="onSubmit()" [disabled]="!isAnythingSelected()">Seleccionar</button>
    </div>
  </div>
